<!--
 * @Author: zhonghao
 * @Date: 2024-04-23 11:14:10
-->
<template>
  <div id="test">
    <div id="demo" v-if="hasData"></div>
    <div class="block-none" v-else>
      <img src="@/assets/images/train/img_none.png" class="img-none" alt="" />
      <div class="block-none-txt">暂无数据</div>
    </div>
    <van-overlay :show="showLoading" @click="showLoading = false">
      <div class="wrapper-loading" @click.stop>
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import { pptranscoding } from '@/api/zone'
export default {
  data() {
    return {
      hasData: true,
      pdfh5: null,
      fileInfo: {},
      showLoading: false
    }
  },
  mounted() {
    this.showLoading = true
    console.log(this.$route.query.pptSrc, '=-=-')
    pptranscoding({url: this.$route.query.pptSrc, isPDF: true}).then(res => {
      if (res) {
        const url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/pdf',
        }))
        // window && window.sessionStorage.setItem('traceTitle', `${this.operationId}-PDF预览`)
        this.pdfh5 = new Pdfh5('#demo', {
          pdfurl: url
        })
      }
      this.showLoading = false
    }).catch(err => {
      if (err.byteLength < 100) {
        this.hasData = false
        return false
      }
      this.pdfh5 = new Pdfh5('#demo', {
        data: err,
        scale: 5
      })
      this.showLoading = false
    })
  },
  methods: {
    // pptxShow(src) {
    //   this.$nextTick(() => {
    //     // eslint-disable-next-line no-undef
    //     $('#pptx').pptxToHtml({
    //       pptxFileUrl: src,
    //       slidesScale: '100%'
    //     })
    //     let timer = setInterval(() => {
    //       // eslint-disable-next-line no-undef
    //       const $slides = $('.slide')
    //       // eslint-disable-next-line no-undef
    //       const $slide = $('.slides')
    //       if ($slides.children().length) {
    //         const slidesWidth = Math.max(
    //           ...Array.from($slides.children()).map((s) => s.offsetWidth)
    //         )
    //         const wrapperWidth = window.innerWidth
    //         let AllHeight = 0
    //         $slides.each(function(key, val) {
    //           console.log(key, val, '23')
    //           // eslint-disable-next-line no-undef
    //           $(this).css({
    //             'transform': `scale(${wrapperWidth / slidesWidth}) translateY(${-1640 * key}px)`,
    //             'transform-origin': 'top left',
    //           })
    //           AllHeight += 790 * wrapperWidth / slidesWidth
    //         })
    //         $slide.css({
    //           'height': `${AllHeight}px`
    //         })
    //         clearInterval(timer)
    //       }
    //     }, 100)
    //   })
    // }
  }
}
</script>

<style lang="less" scoped>
#demo {
  width: 100vw;
  height: 100vh;
}
.block-none {
  padding-top: 240px;
  box-sizing: border-box;
  .img-none {
    width: 120px;
    height: 104px;
    margin-bottom: 12px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .block-none-txt {
    font-size: 14px;
    color: #5b5f6a;
    line-height: 20px;
    text-align: center;
  }
}
.wrapper-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/pptView.vue